import { TreeModule } from '@ali-hm/angular-tree-component'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatTooltipModule } from '@angular/material/tooltip'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { NgSelectModule } from '@ng-select/ng-select'
import { I18nModule } from '@spartacus/core'
import { IconModule, ItemCounterModule } from '@spartacus/storefront'
import { ExcludedItemsComponent } from './bottom-sheets/excluded-items/excluded-items.component'
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component'
import { CookiesPolicyModule } from './cookies-policy/cookies-policy.module'
import { CreditHoldMessageComponent } from './credit-hold-message/credit-hold-message.component'
import { CustomComponentsModule } from './custom-components/custom-components.module'
import { ErrorComponent } from './error/error.component'
import { MaterialModule } from './material.module'
import { MinimumDispatchTimeComponent } from './minimum-dispatch-time/minimum-dispatch-time.component'

@NgModule({
  declarations: [
    ConfirmModalComponent,
    CreditHoldMessageComponent,
    ExcludedItemsComponent,
    MinimumDispatchTimeComponent,
    ErrorComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    NgSelectModule,
    ItemCounterModule,
    FormsModule,
    NgbTooltipModule,
    MaterialModule,
    IconModule,
    CustomComponentsModule,
    TreeModule,
    CookiesPolicyModule
  ],
  exports: [
    ConfirmModalComponent,
    CreditHoldMessageComponent,
    ExcludedItemsComponent,
    CommonModule,
    I18nModule,
    NgSelectModule,
    CustomComponentsModule,
    TreeModule,
    NgbTooltipModule,
    MatTooltipModule,
    MinimumDispatchTimeComponent,
    ErrorComponent
  ]
})
export class SharedModule {}
